export default __webpack_public_path__ + "static/media/skullpunksnftupdaetd.8d3b1249.png";